import { isEmpty } from 'lodash-es';
import Cookies from 'js-cookie';
import qs from 'qs';
// 导入埋点和监控库
import Probe from '@tencent/manta-probe-web';
import ProbePluginPv from '@tencent/manta-probe-web/es/plugins/pv';
import ProbePluginTrack from '@tencent/manta-probe-web/es/plugins/track';
import ProbePluginExpose from '@tencent/manta-probe-web/es/plugins/expose';

import Vuex from 'vuex';
// 注册全局指令
import { VueTransferDom } from 'vue2-transfer-dom';
import VueCompositionAPI from '@vue/composition-api';

import { common } from '@tencent/ceiba-base-components';

// {{import plugins}}
import astPlugin from '@tencent/ceiba-act-public-plugin-ast';
import loginPlugin from '@tencent/ceiba-act-public-plugin-login';
import reportPlugin from '@tencent/ceiba-act-public-plugin-report';
import dialogPlugin from '@tencent/ceiba-act-public-plugin-dialog';
import requestPlugin from '@tencent/ceiba-act-public-plugin-request';
import openerPlugin from '@tencent/ceiba-act-public-plugin-opener';

function walkData(data, fn) {
  if (Array.isArray(data)) {
    data.forEach(item => walkData(item, fn));
  } else {
    fn(data);
    const { children } = data;
    if (children) {
      walkData(children, fn);
    }
  }
}

// 从url中兼容获取上报的trace_id,放到ext中
const currentQuery = qs.parse(window?.location.search.substring(1));
const reportExt = {};
if (Object.prototype.hasOwnProperty.call(currentQuery, 'trace_id')) {
  reportExt.trace_id = currentQuery.trace_id;
}
if (Object.prototype.hasOwnProperty.call(currentQuery, 'track_id')) {
  reportExt.trace_id = currentQuery.track_id;
}


/**
 * 将树状组件列表扁平化.
 * children组件直接按顺序排到紧邻父组件之后.
 * 方便遵循规则快速恢复树状结构.
 * @param {array} componentList 包含children的树状组件列表
 * @returns {array} 一维数组的组件列表
 */
const flattenComponentList = (componentList) => {
  const flattenedList = [];
  // 当前一层嵌套
  componentList.forEach((component) => {
    const newParent = JSON.parse(JSON.stringify(component)); // 深拷贝防止污染原有state
    if (JSON.stringify(newParent.childrenSlots || {}) !== '{}') {
      // 存在多slot子组件
      const { childrenSlots } = newParent; // 深拷贝防止污染原有state
      // 删除parent的children属性后再push, 防止渲染时产生duplicate key
      delete newParent.childrenSlots;
      // 直接遍历子组件,push到父组件之后
      for (const [key, value] of Object.entries(childrenSlots)) {
        value.forEach((child) => {
          const newChild = child;
          if (JSON.stringify(newChild.childrenSlots || {}) !== '{}') {
            const { childrenSlots } = newChild; // 深拷贝防止污染原有state
            delete newChild.childrenSlots;
            for (const [key, value] of Object.entries(childrenSlots)) {
              value.forEach((child) => {
                const newChildChild = child;
                newChildChild.parentId = newChild.id;
                newChildChild.slotName = key;
                flattenedList.push(newChildChild);
              });
            }
          }
          newChild.parentId = newParent.id;
          newChild.slotName = key;
          flattenedList.push(newChild);
        });
      }
    }
    flattenedList.push(newParent);
  });
  return flattenedList;
};


const transformComponentListStyle = (components) => {
  const componentConfig = [];
  components.forEach((com) => {
    const component = com;
    Object.keys(component.styles).forEach((key) => {
      component.styles[key] = common.tool.transformStyle(component.styles[key]);
    });
    if (Array.isArray(component.children) && component.children.length > 0) {
      component.children = transformComponentListStyle(component.children);
    }
    if (!isEmpty(component.childrenSlots)) {
      for (const [key, value] of Object.entries(component.childrenSlots)) {
        component.childrenSlots[key] = transformComponentListStyle(value);
      }
      // 当组件为轮播图容器组件时，复制第一份数据追加到末尾
      if (component.component === 'c-carousel') {
        const arr = Object.keys(component.childrenSlots);
        component.childrenSlots[arr.length] = (component.childrenSlots[arr[0]]);
        console.log('c-carousel=', component.childrenSlots);
      }
    }
    componentConfig.push(component);
  });
  return componentConfig;
};

const transformComponentListEvent = (components) => {
  let eventList = [];
  components.forEach((com) => {
    const component = com;
    const componentEvents = component.events || [];
    if (componentEvents.length === 0) return;
    for (let i = 0, len = componentEvents.length; i < len; i++) {
      if (componentEvents[i].trigger.startsWith('ceiba:component:events:')) {
        // 组件联动自定义事件
        const eventData = componentEvents[i].data || [];
        // eslint-disable-next-line no-loop-func
        eventData.forEach((data) => {
          eventList.push({
            type: componentEvents[i].trigger,
            from: component.id,
            to: data.target,
            method: data.method,
          });
        });
      }
    }
    if (Array.isArray(component.children) && component.children.length > 0) {
      eventList = eventList.concat(transformComponentListEvent(component.children));
    }
  });
  return eventList;
};


const selectDefaultPage = (pages) => {
  let defaultPageId;
  const cPage = common.tool.getQueryparams('c_page');
  if (cPage) {
    const pageIndex = parseInt(cPage, 10);
    pages.forEach((item, index) => {
      if (index === pageIndex) {
        defaultPageId = item.id; // 找到对应index的pageid
      }
    });
    if (defaultPageId) return defaultPageId;
  }
  walkData({ children: pages }, (item) => {
    if (!item.children && !defaultPageId) {
      defaultPageId = item.id;
    }
  });
  return defaultPageId;
};

function initActInfo(actInfo) {
  const actConfig = actInfo;
  let extendConfig = {};
  if (actConfig.extend_config) {
    extendConfig = JSON.parse(actConfig.extend_config);
  }
  actConfig.extendConfig = Object.assign({
    forceLogin: true,
    forceRole: true,
    entryPlugins: [],
    beforeStartPlugins: [],
    afterEndPlugins: [],
    offlinePlugins: [],
  }, extendConfig);
  actConfig.flattenComponents = {};

  const { configs } = actConfig.config;
  console.log('initActInfo configs=', configs);
  Object.keys(configs).forEach((pageId) => {
    // 处理组件联动事件
    configs[pageId].events = transformComponentListEvent(configs[pageId].componentConfig);
    console.log('init events=', configs[pageId].events);
    // 处理渲染预处理
    if (![1, 3].includes(actInfo.channel_type)) return;
    configs[pageId].componentConfig = transformComponentListStyle(configs[pageId].componentConfig);
    const flatComponents = flattenComponentList(configs[pageId].componentConfig);
    flatComponents.forEach((com) => {
      actConfig.flattenComponents[com.id] = com;
    });
    if (configs[pageId]?.canvasConfig) {
      configs[pageId].canvasConfig.dialogConfig = common.tool.transformStyle(configs[pageId].canvasConfig.dialogConfig);
    }
  });
  actConfig.page_id = selectDefaultPage(actConfig.config.pages);
  console.log('actConfig', actConfig);
  return actConfig;
}

function initReport(actInfo) {
  if (typeof window !== 'undefined') {
    // 优先获取url上的参数
    let appIdQuery = '';
    let openIdQuery = '';
    let acctypeQuery = '';
    let accessTokenQuery = '';
    if (Object.prototype.hasOwnProperty.call(currentQuery, 'appid')) {
      appIdQuery = currentQuery.appid;
      Cookies.set('appid', appIdQuery);
    }
    if (Object.prototype.hasOwnProperty.call(currentQuery, 'openid')) {
      openIdQuery = currentQuery.openid;
      Cookies.set('openid', openIdQuery);
    }
    if (Object.prototype.hasOwnProperty.call(currentQuery, 'access_token')) {
      accessTokenQuery = currentQuery.access_token;
      Cookies.set('access_token', accessTokenQuery);
    }
    if (Object.prototype.hasOwnProperty.call(currentQuery, 'acctype')) {
      acctypeQuery = currentQuery.acctype;
      // 超核的qc兼容逻辑
      if (acctypeQuery === 'qq' && accessTokenQuery.length > 10) {
        acctypeQuery = 'qc';
      }
      if (acctypeQuery === 'weixin') {
        acctypeQuery = 'wx';
      }
      Cookies.set('acctype', acctypeQuery);
    }
    // 挂载数据上报sdk - UPProbe
    /**
     * data_source
        一级	二级	data_source
        App原生	\	1
        PC	\	2
        游戏内置面板	\	3
        微官网	\	4
        H5	APP内	21
        H5	浏览器	12
        H5	PC	22
        H5	微信公众号	11
        H5	微信小程序	23
        H5	QQ公众号	10
        H5	QQ小程序	24
        其它	\	0
     */
    if (!window.navigator.userAgent.match(/tgclub/i)) {
      // 心悦业务&活动UA不在app内
      window.dataSource = 12;
    } else {
      // 浏览器H5 https://mirrors.tencent.com/#/private/npm/detail?repo_id=537&project_name=%40tencent%2Fmanta-probe-web#data_source
      window.dataSource = 21;
    }
    const reportOptions = {
      spa: true,
      publicParams: {
        product_id: 4, // 1=心悦、2=小悦、3=超R、4=ceiba
        data_source: window.dataSource,
        business_id: String(actInfo.second_business_id),
      },
      plugins: [
        [ProbePluginPv],
        [ProbePluginTrack],
        [ProbePluginExpose, { stayTime: 2000 }],
      ],
    };

    // 默认pageId为5001(主页)
    window.reportPageId = 5001;
    // 按业务修改product_id配置
    switch (actInfo.ast) {
      case 'tgclub':
        reportOptions.publicParams.product_id = [1, 4];
        if (!window.navigator.userAgent.match(/tgclub/i)) {
          // 心悦业务&活动UA不在app内,设置pageId为5002(引流页)
          window.reportPageId = 5002;
        }
        break;
      case 'gbot':
        reportOptions.publicParams.product_id = [2, 4];
        break;
      case 'supercore':
        reportOptions.publicParams.product_id = [3, 4];
        break;
      case 'bb':
        reportOptions.publicParams.product_id = [4, 5];
        break;
      default:
        break;
    }
    if (!['prod', 'prerelease'].includes(window.CEIBA_ENV)) {
      reportOptions.env = 'test';
    }

    reportOptions.publicParams.data_source = window.dataSource;

    // 直接初始化url上的登录参数
    if (appIdQuery) {
      reportOptions.publicParams.cus_appid = appIdQuery;
    }
    if (openIdQuery) {
      reportOptions.publicParams.cus_uin = openIdQuery;
    }
    if (acctypeQuery) {
      const LOGIN_TYPE_MAP = {
        qq: 1,
        wx: 2,
        qc: 3,
      };
      reportOptions.publicParams.login_type = LOGIN_TYPE_MAP[acctypeQuery];
    }

    const ceibaReporter = new Probe(reportOptions);
    ceibaReporter.on('enterPage', ({ }) => {
      const ceibaExt = {
        ceiba_business_id: actInfo.ast,
        ceiba_activity_id: actInfo.activity_id,
        ceiba_component_id: 'v100001', // 默认pv
        ceiba_component_uid: actInfo.page_id, // 默认pv,用活动的page_id
        ceiba_page_id: actInfo.page_id,
        ceiba_activity_type: actInfo.activity_type,
      };
      // 1001 页面曝光
      ceibaReporter.enterPage({
        page_id: window.reportPageId,
        event_id: 1001,
        game_id: actInfo?.gid, // 取心悦gid为game_id
        data_id: actInfo.report_config['1001'],
        ceiba_ext: JSON.stringify(ceibaExt),
        ext: reportExt,
        activity_id: actInfo.uo_id, // 增加上报uo活动id
      });
    });
    window.ceibaReporter = ceibaReporter;
    console.log(ceibaReporter);
  }
}

export default {
  initActInfo,
  initReport,
  install(Vue) {
    Vue.use(VueTransferDom /* , {name: 'transferDom'}*/);
    Vue.use(VueCompositionAPI);

    Vue.prototype.$env = common.env;
    Vue.prototype.$platform = common.platform;

    Vue.prototype.$isInEditor = false;

    // 事件总线
    if (!Vue.prototype.$eventBus) {
      Vue.prototype.$eventBus = new Vue();
    }


    // 注册平台公用插件
    // 弹窗插件
    Vue.use(dialogPlugin);
    // 请求插件
    Vue.use(requestPlugin);
    // 业务插件：唯一
    Vue.use(astPlugin);
    // 登录插件
    Vue.use(loginPlugin);
    // 上报插件
    Vue.use(reportPlugin, {});
    // 打开跳转插件
    Vue.use(openerPlugin);
    // mixins，组件内方法
    Vue.mixin({
      computed: {
        ...Vuex.mapState([
          'bindRoleList',
        ]),
        ...Vuex.mapGetters([
          'ctx',
          'isLogin',
          'isAuth',
          'userInfo',
          'inviteUserInfo',
          'isRoleReady',
          'roleInfo',
          'quaInfo',
          'pageInfo',
          'shareConfig',
          'pageMeta',
          'reportConfig',
          'dialogConfig',
          'userAuth',
          'actInfo',
          'deviceMode',
          'isRoleStatusValid',
          'rootFontSize',
          'reportExt',
        ]),
      },
      methods: {
        ...Vuex.mapActions([
          'checkLogin',
          'logout',
          'login',
          'flowRequest',
          'doHook',
          'refreshQua',
          'checkRoleInfo',
          'saveCurrentRole',
          'doShare',
          'reportClick',
          'reportClickRaw',
          'reportExpose',
          'reportExposeRaw',
          'reportCustomEvent',
          'reportFlush',
          'updatePageId',
          'setCustomStorage',
          'assignUserInfo',
          'getBindRoleListByScene',
          'bindRoleByScene',
        ]),
      },
    });
    // mixins，组件内工具方法
    Vue.prototype.$onQuaRefreshed = (cb) => {
      Vue.prototype.$eventBus.$on('ceiba:common:events:qua-refreshed', cb);
    };
    Vue.prototype.$onLogined = (cb) => {
      Vue.prototype.$eventBus.$on('ceiba:common:events:logined', cb);
    };
    Vue.prototype.$onLogout = (cb) => {
      Vue.prototype.$eventBus.$on('ceiba:common:events:logout', cb);
    };
    Vue.prototype.$onRoleReady = (cb) => {
      Vue.prototype.$eventBus.$on('ceiba:common:events:role-ready', cb);
    };
  },
};
